export function escapeWhiteSpaces(url: string): string {
  if (url) return url.replace(/\s/g, '%20');
  return url;
}
